import React, { useState } from 'react';
import { theme } from '../../theme';

// <purpose>Stub modal for selecting date ranges older than 12 months (overflow pill → this).</purpose>
// <dependencies>theme</dependencies>
// <constraints>Stub only — full implementation deferred. onApply returns YYYY-MM-DD strings.</constraints>

type Props = {
    open: boolean;
    onClose: () => void;
    onApply: (startDate: string, endDate: string) => void; // YYYY-MM-DD
};

export const CustomRangeModal: React.FC<Props> = ({ open, onClose, onApply }) => {
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    if (!open) return null;
    const canApply = Boolean(start && end && start <= end);
    return (
        <div style={modalBackdropStyle} onClick={onClose}>
            <div onClick={e => e.stopPropagation()}>
            <div
                role="dialog"
                aria-label="Benutzerdefinierten Zeitraum wählen"
                style={modalContentStyle}
            >
                <h4 style={{ marginTop: 0, color: theme.colors.navy, fontSize: 14, fontFamily: theme.font.family }}>
                    Benutzerdefinierten Zeitraum wählen
                </h4>
                <p style={{ fontSize: 11, color: theme.colors.textSecondary, marginBottom: 12, fontFamily: theme.font.family }}>
                    Für Zeiträume außerhalb der letzten 12 Monate.
                </p>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
                    <span style={{ fontSize: 11, fontFamily: theme.font.family }}>Von</span>
                    <input
                        type="date"
                        value={start}
                        onChange={e => setStart(e.target.value)}
                        style={inputStyle}
                        aria-label="Startdatum"
                    />
                    <span style={{ fontSize: 11, fontFamily: theme.font.family }}>Bis</span>
                    <input
                        type="date"
                        value={end}
                        onChange={e => setEnd(e.target.value)}
                        style={inputStyle}
                        aria-label="Enddatum"
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <button onClick={onClose} style={cancelBtnStyle}>Abbrechen</button>
                    <button
                        onClick={() => { if (canApply) { onApply(start, end); onClose(); } }}
                        disabled={!canApply}
                        style={applyBtnStyle(!canApply)}
                    >
                        Anwenden
                    </button>
                </div>
            </div>
            </div>
        </div>
    );
};

const modalBackdropStyle: React.CSSProperties = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
const modalContentStyle: React.CSSProperties = {
    background: 'white', padding: 20, borderRadius: 6, minWidth: 320,
    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
};
const inputStyle: React.CSSProperties = {
    padding: '4px 8px', fontSize: 11, border: '1px solid #ccc', borderRadius: 4,
};
const cancelBtnStyle: React.CSSProperties = {
    padding: '6px 12px', fontSize: 11, background: 'white',
    border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer',
    fontFamily: theme.font.family,
};
function applyBtnStyle(disabled: boolean): React.CSSProperties {
    return {
        padding: '6px 12px', fontSize: 11,
        background: disabled ? '#ccc' : theme.colors.navy,
        color: 'white', border: 'none', borderRadius: 4,
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: theme.font.family,
    };
}
